module.exports = __webpack_public_path__ + "static/img/pMRI6.667fcdb7.png";